import { useMutation, useQueryClient } from "@tanstack/react-query";
import { permissionsService } from "@/features/permissions/services/permissionsService";
import { handleApiError, toastMutationSuccess } from "@/lib/error-handler";
import { queryKeys } from "@/lib/query-keys";
import type {
  RolePermissionBulkInput,
  UserPermissionBulkInput,
} from "@/types/permission";

export function useUpdateRolePermissionTemplates() {
  const queryClient = useQueryClient();
  return useMutation<void, Error, RolePermissionBulkInput>({
    mutationFn: (data) => permissionsService.updateRoleTemplates(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.permissions.all });
      toastMutationSuccess(null, { fallbackMessage: "تم حفظ قوالب الأدوار بنجاح" });
    },
    onError: (error) => handleApiError(error),
  });
}

export function useUpdateUserPermissions(userId: string) {
  const queryClient = useQueryClient();
  return useMutation<void, Error, UserPermissionBulkInput>({
    mutationFn: (data) => permissionsService.updateUserPermissions(userId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.permissions.user(userId),
      });
      toastMutationSuccess(null, { fallbackMessage: "تم حفظ صلاحيات المستخدم بنجاح" });
    },
    onError: (error) => handleApiError(error),
  });
}
